export default __webpack_public_path__ + "86133b8d78a82225db9ff3b50bf2a3bc.svg";